/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Box } from '@material-ui/core';
import useStyles from './useStyles';

const Footer = ({ onCancel, onOk }) => {
  const { labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;
  const classes = useStyles();

  return (
    <Box className={classes.footer}>
      <Button
        variant="outlined"
        color='primary'
        className={classes.secondaryButton}
        onClick={onCancel}
      >
        {labels.DESIGNER_CANCEL}
      </Button>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={onOk}
      >
        {labels.DESIGNER_OK}
      </Button>
    </Box>
  );
};

export default Footer;
